/**
 * @description
 * Objeto AvisTipusEnviament
 */

export class AvisTipusEnviament {
    public id:number = null;
    public code:string = "";
    public descript:string = "";

    constructor() {}
}